import React, { useMemo } from "react";
import { Sport } from "../../../../types/model";
import { RootState } from "../../../../store/store";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { setSelectedSport } from "../../../../store/slices/fantasySlice";
import {
	getEventSports,
	getFutureEvents,
	getSeasonEvents,
} from "../../../../utils/helper";

const SportFilter = () => {
	const { selectedSport, selectedSeason, events } = useAppSelector(
		(state: RootState) => state.fantasy,
	);
	const dispatch = useAppDispatch();

	const handleSportChange = (sportId: string) => {
		const _selectedSport = availableSports.find(
			(sport: Sport) => sport._id === sportId,
		);
		if (!_selectedSport) {
			return;
		}
		dispatch(setSelectedSport(_selectedSport));
	};

	const availableSports = useMemo(() => {
		const seasonEvents = getSeasonEvents(events, selectedSeason._id ?? "");
		return getEventSports(getFutureEvents(seasonEvents));
	}, [events, selectedSeason._id]);

	return (
		<div className="fantasy-sport-toggle" role="group" aria-label="Select sport">
			{availableSports.map((sport: Sport) => (
				<button
					key={sport._id}
					type="button"
					className={`fantasy-sport-toggle__button ${sport._id === selectedSport?._id ? "fantasy-sport-toggle__button--active" : ""}`}
					onClick={() => handleSportChange(sport._id)}
				>
					{sport.name.toLocaleUpperCase()}
				</button>
			))}
		</div>
	);
};

export default SportFilter;
